module.exports = __webpack_public_path__ + "img/blue-square-table-1.e21f8dd0.png";